import { Switch } from "@/components/ui/switch";
import { shortDate } from "@/lib/format";

const monthName = (mk) => new Date(`${mk}-01T00:00:00`).toLocaleString("en-ZA", { month: "short" });

export const AutoBudgetToggle = ({ auto, onToggle }) => {
  const basis = auto.months.length ? `${monthName(auto.months[0])}–${monthName(auto.months[auto.months.length - 1])}` : null;
  return (
    <div data-testid="auto-budget-card" className="mb-4 flex items-start justify-between gap-4 rounded-xl bg-secondary/60 px-4 py-3">
      <div>
        <div className="text-sm font-medium text-riq-primary">Automatic budgets</div>
        <p data-testid="auto-budget-status" className="mt-0.5 text-xs text-muted-foreground">
          {auto.on
            ? (basis
              ? `Set from your ${basis} average (incl. subscriptions), rounded up to R100${auto.updated ? ` · updated ${shortDate(auto.updated)}` : ""}. Refreshes on the 1st of each month — manual edits are replaced then.`
              : "Refreshes on the 1st of each month from your last 3 months' average, once you have a full month of spending.")
            : "Turn on to set your total and category budgets from your last 3 months' average every 1st of the month."}
        </p>
      </div>
      <Switch data-testid="auto-budget-switch" checked={auto.on} onCheckedChange={onToggle} />
    </div>
  );
};
